// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice__message-text[data-v-9cef7fde]{display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical}.notice .notice__message-icon img[data-v-9cef7fde]{max-width:15px}.notice .notice__message-img[data-v-9cef7fde]{background-color:transparent}.fade-enter-active[data-v-9cef7fde],.fade-leave-active[data-v-9cef7fde]{transition:opacity .2s}.fade-enter[data-v-9cef7fde],.fade-leave-to[data-v-9cef7fde]{opacity:0}", ""]);
// Exports
module.exports = exports;
